function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 15 19" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.73 5.071H.163V13.8H5.73v4.636l9.05-9-9.05-9v4.636" /></svg>;
});